import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, CustomerLookup } from 'shared/types';

export function useGetBillToAddress(query: string, brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isFetching, isLoading } = useQuery<Record<string, string>[], Error>(
    ['customer', query],
    () =>
      quoteService.autoCompleteSearch<CustomerLookup>({
        query,
        brand,
        searchColumn: 'customernumber',
        table: 'customers',
      }),
    {
      initialData: [],
      enabled: Boolean(query),
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
    }
  );

  const address: string | undefined = data ? data[0]?.billtoaddress : undefined;

  return { address, isFetching, isLoading } as const;
}
